import { Spanish } from "../../languages";
import { LanguageDispatchProps } from "./language.props";

const languageState: LanguageDispatchProps = {
  t: Spanish,
  currentLanguage: "es",
  dispatch: () => null,
};

export default languageState;